export default {
    myTeam: null,
    additional: null
}